import {
    Stepper,
    Step,
    StepLabel,
    Box,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    DialogActions,
    Button,
    Backdrop
} from "@mui/material";
import { useEffect, useState } from "react";
import React from "react";
import { BtnFooter } from "./BtnFooter";
import ConfirmRfqDetails from "./ConfirmRfqDetails";
import { mmRfqFormDataSelector } from "../../Redux/MMRfq/Selector";
import { createStructuredSelector } from "reselect";
import { connect, useDispatch } from "react-redux";
import AddDocuments from "./AddDocuments";
import { useBeforeUnloadPrompt } from "../../hooks/useUnsavedChangesPrompt";
import { useLocation, useNavigate } from "react-router-dom";
import SelectVendor from "./SelectVendor";
import { ThreeDot } from "react-loading-indicators";
import { FileProvider, useFileContext } from "./FileContext";
import {
    createInternalMMRfq,
    getSendEmailToPartnerAllMMRfq,
    getSendEmailToPartnerAllMMRfqPart,
    updateExtendMMRfqDate,
    updatePartnerMMRfq,
    uploadMMRfqPartFileAPI,
    uploadMMRfqTechnicalFileAPI
} from "../Services/MMRfqForm";
import {
    getLoggedInUserID,
    mmRfqAttachmentUploadDrawingFile,
    mmRfqUploadTechDetailsFile
} from "../../Utils/Constant";
import { showToast } from "../../Components/Toast";
import { setMmRfqFormData } from "../../Redux/MMRfq/actions";
const steps = [
    "Confirm RFQ Details & Part Details",
    "Add Documents & Comments",
    "Select Partners"
];

const StepperComponent = ({ MM_RFQ_FORM_DATA }) => {
    const { addFile, removeFile, getFile } = useFileContext();
    const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
    const [isAssigning, setIsAssigning] = useState(false);
    const location = useLocation();
    const dispatch = useDispatch();
    const locationData = location?.state;
    const handleCloseDialog = () => {
        setOpenRemoveDialog(false);
    };

    const [activeStep, setActiveStep] = useState(
        locationData?.from === "EditDueDateOfMMrfq" ||
            locationData?.from === "addPartnerForMMrfq"
            ? 2
            : 0
    );
    useBeforeUnloadPrompt(
        true,
        "You have unsaved changes. Are you sure you want to leave?"
    );

    const uploadForm = async () => {
        setIsAssigning(true);
        try {
            const partDetails = MM_RFQ_FORM_DATA[0]?.Part_Details?.map(
                (item) => ({
                    Part_ID: item?.ID,
                    Part_Number: item?.ID,
                    Part_Name: item?.ID,
                    Part_Number_original: item?.Part_Number,
                    Part_Name_original: item?.Part_Name,
                    Solution: item?.Solutions,
                    Raw_Material: item?.Raw_Material,
                    Target_Price: item?.Target_Price,
                    Qty_Year: item?.Qty_year,
                    Qty_Batch: item?.Qty_Batch,
                    UOM: item?.UOM,
                    Total: item?.Total_Order_Value,
                    Type_of_Order: item?.Type_of_Order,
                    Mandatory_Inspection: item?.Mandatory_Inspection,
                    Packing: item?.Packing,
                    Samples_Required: item?.Sample_Required,
                    Upload_Drawing: item?.Upload_Drawing,
                    Select_Partners: item?.selectedVendorsID,
                    Due_Date: MM_RFQ_FORM_DATA[0]?.expiryDate,
                    Approved: "No"
                })
            );

            const payload = {
                Rfq_Details: {
                    Customer_RFQ_Name:
                        MM_RFQ_FORM_DATA[0]?.Rfq_Details?.Customer_RFQ_ID,
                    CORFQ_ID: MM_RFQ_FORM_DATA[0]?.Rfq_Details?.Customer_RFQ_ID,
                    // MM_RFQ_Name: MM_RFQ_FORM_DATA[0]?.Rfq_Details?.MM_RFQ_Name,
                    Upload_Technical_Details:
                        MM_RFQ_FORM_DATA[0]?.TechnicalDetails
                            ?.Upload_Technical_File,
                    Compliance_Requirements:
                        MM_RFQ_FORM_DATA[0]?.TechnicalDetails?.compliance,
                    Quality_Standards:
                        MM_RFQ_FORM_DATA[0]?.TechnicalDetails?.quality_standard,
                    Add_Comments:
                        MM_RFQ_FORM_DATA[0]?.TechnicalDetails?.comments,
                    Due_Date: MM_RFQ_FORM_DATA[0]?.expiryDate,
                    Sourcing_Manager: getLoggedInUserID()
                },
                Part_Details: partDetails
            };

            const response = await createInternalMMRfq(payload);

            if (response?.status) {
                try {
                    await Promise.all(
                        response?.data[0]?.MMRFQ_IDs.map((item) => {
                            const file = getFile("Upload_Technical_Details");
                            if (!file) return Promise.resolve();
                            return uploadMMRfqTechnicalFileAPI({
                                recordId: item,
                                uploadField: "Upload_Technical_Details",
                                fileUpload: file
                            });
                        })
                    );

                    await Promise.all(
                        response?.data[0]?.MMRFQ_PART_IDs.map((item) => {
                            const file = getFile(item.partnumber);
                            if (!file) return Promise.resolve();
                            return uploadMMRfqPartFileAPI({
                                recordId: item.rowID,
                                uploadField: "Upload_Drawing",
                                fileUpload: file
                            });
                        })
                    );

                    await getSendEmailToPartnerAllMMRfq({
                        MMRFQ_IDs: response?.data[0]?.MMRFQ_IDs
                    });

                    showToast({
                        message: `MMRFQ(s) created`,
                        type: "success"
                    });
                    navigate("/layout/CURFQAssignedToMe");
                    setIsAssigning(false);
                } catch (uploadError) {
                    setIsAssigning(false);
                    showToast({
                        message: `Error while submitting the form.`,
                        type: "error"
                    });
                }
            } else {
                setIsAssigning(false);

                showToast({
                    message: `Error while submitting the form.`,
                    type: "error"
                });
            }
        } catch (err) {
            setIsAssigning(false);
            showToast({
                message: `Error while submitting the form.`,
                type: "error"
            });
        }
    };
    const updateExtendDate = async () => {
        setIsAssigning(true);

        try {
            let payload = {
                mmRfqID: MM_RFQ_FORM_DATA[0]?.Rfq_Details?.MMRFQ_Row_ID,
                extendedDueDate: MM_RFQ_FORM_DATA[0]?.expiryDate,
                prevDueDate: MM_RFQ_FORM_DATA[0]?.previousExpiryDate
            };
            let response = await updateExtendMMRfqDate(payload);
            if (response?.status) {
                showToast({
                    message: "MMRFQ(s) end date extended",
                    type: "success"
                });
                navigate("/layout/AllMmrfq", {
                    state: {
                        rfqData: {
                            ID: locationData?.rfqData?.ID,
                            rfqID: locationData?.rfqData?.rfqID,
                            assigneeName: locationData?.rfqData?.assigneeName
                        },
                        from: "CURFQAssignedToMe"
                    }
                });
            } else {
                showToast({
                    message: "Failed To Update Data",
                    type: "error"
                });
            }
        } catch (err) {
            showToast({
                message: "Failed To Update Data",
                type: "error"
            });
        } finally {
            setIsAssigning(false);
        }
    };

    const updatePartnerPerParts = async () => {
        setIsAssigning(true);
        try {
            let payload = {
                internalMMRFQPartID: MM_RFQ_FORM_DATA[0]?.Part_Details[0]?.ID,
                addedPartnerIDs:
                    MM_RFQ_FORM_DATA[0]?.Part_Details[0]?.selectedVendorsID
            };
            let response = await updatePartnerMMRfq(payload);
            if (response?.status) {
                const newVendors =
                    MM_RFQ_FORM_DATA[0]?.Part_Details[0]?.selectedVendors.filter(
                        (item) =>
                            !MM_RFQ_FORM_DATA[0]?.Part_Details[0]?.previousSelectedVendors.includes(
                                item
                            )
                    );
                const recID = MM_RFQ_FORM_DATA[0]?.ID;
                const partDetail = MM_RFQ_FORM_DATA[0]?.Part_Details[0];
                const rfqDetail = MM_RFQ_FORM_DATA[0]?.Rfq_Details;
                const tessting = mmRfqUploadTechDetailsFile(
                    MM_RFQ_FORM_DATA[0]?.Upload_Technical_Details
                );
                console.log("testing", tessting);
                // let split = partDetail?.Upload_Drawing?.split("filepath=");
                // let technicalDetailsFileSplit =
                //   MM_RFQ_FORM_DATA[0]?.Upload_Technical_Details?.split("filepath=");
                const partnerData = partDetail?.Partner_Lists?.filter((item) =>
                    newVendors.includes(item?.partnerName)
                )?.map((item) => ({
                    ID: recID,
                    Part_ID: partDetail?.Part_ID,
                    Part_Number: partDetail?.Part_Number,
                    Part_Name: partDetail?.Part_Name,
                    Target_Price: partDetail?.Target_Price,
                    Type_of_Order: partDetail?.Type_of_Order,
                    Qty_Year: partDetail?.Qty_year,
                    Qty_Batch: partDetail?.Qty_Batch,
                    UOM: partDetail?.UOM,
                    Sample_Required: partDetail?.Sample_Required,
                    Total_Order_Value: partDetail?.Total_Order_Value,
                    Upload_Drawing: mmRfqAttachmentUploadDrawingFile(
                        partDetail?.Upload_Drawing
                    ),
                    Partner_Name: item?.partnerName,
                    Partner_ID: item?.Partner_ID,
                    MMRFQ_ID: rfqDetail?.MMRFQ_ID,
                    RFQ_End_Date: rfqDetail?.RFQ_End_Date,
                    sourcing_mn_name: partDetail?.sourcing_head_name,
                    sourcing_mn_email: partDetail?.sourcing_head_email,
                    Upload_Technical_Details: mmRfqUploadTechDetailsFile(
                        MM_RFQ_FORM_DATA[0]?.Upload_Technical_Details
                    ),
                    Compliance_Requirements:
                        MM_RFQ_FORM_DATA[0]?.Compliance_Requirements || "-",
                    Quality_Standards:
                        MM_RFQ_FORM_DATA[0]?.quality_standard || "-",
                    Add_Comments: MM_RFQ_FORM_DATA[0]?.Add_Comments || "-"
                }));
                await getSendEmailToPartnerAllMMRfqPart({
                    Partners: partnerData
                });
                showToast({
                    message: `Partner(s) added for ${MM_RFQ_FORM_DATA[0].Rfq_Details?.MMRFQ_ID}`,
                    type: "success"
                });
                navigate("/layout/AllMmrfq", {
                    state: {
                        rfqData: {
                            ID: locationData?.rfqData?.ID,
                            rfqID: locationData?.rfqData?.rfqID,
                            assigneeName: locationData?.rfqData?.assigneeName
                        },
                        from: "CURFQAssignedToMe"
                    }
                });
            } else {
                showToast({
                    message: "Failed To Update Data",
                    type: "error"
                });
            }
        } catch (err) {
            showToast({
                message: "Failed To Update Data",
                type: "error"
            });
        } finally {
            setIsAssigning(false);
        }
    };
    const validateStep = () => {
        if (activeStep === 0) {
            // const rfqName = MM_RFQ_FORM_DATA[0]?.Rfq_Details?.MM_RFQ_Name;

            const partsInfo = MM_RFQ_FORM_DATA[0]?.Part_Details?.filter(
                (item) =>
                    // !item?.Target_Price ||
                    // !item?.Total_Order_Value ||
                    !item?.Upload_Drawing
            );

            if (partsInfo?.length > 0) {
                const updatedFormData = [...MM_RFQ_FORM_DATA];
                updatedFormData[0] = {
                    ...updatedFormData[0],
                    isNextButtomClicked: true
                };

                dispatch(setMmRfqFormData(updatedFormData));
                alert("Please fill all the required inputs");

                return false;
            }
        } else if (activeStep === 1) {
            const updatedFormData = [...MM_RFQ_FORM_DATA];
            updatedFormData[0] = {
                ...updatedFormData[0],
                isNextButtomClicked: false
            };

            dispatch(setMmRfqFormData(updatedFormData));
            // const tecanicalDetailsFile =
            //   MM_RFQ_FORM_DATA[0]?.TechnicalDetails?.Upload_Technical_File;

            // if (!tecanicalDetailsFile) {
            //   const updatedFormData = [...MM_RFQ_FORM_DATA];
            //   updatedFormData[0] = {
            //     ...updatedFormData[0],
            //     isNextButtomClicked: true,
            //   };

            //   dispatch(setMmRfqFormData(updatedFormData));
            //   alert("Please fill all the required inputs");
            //   return false;
            // }
        } else if (activeStep === 2) {
            const updatedFormData = [...MM_RFQ_FORM_DATA];
            updatedFormData[0] = {
                ...updatedFormData[0],
                isNextButtomClicked: false
            };

            dispatch(setMmRfqFormData(updatedFormData));
            const partsInfo = MM_RFQ_FORM_DATA[0]?.Part_Details?.filter(
                (item) => item?.selectedVendors?.length < 2
            );
            if (partsInfo?.length > 0) {
                const updatedFormData = [...MM_RFQ_FORM_DATA];
                updatedFormData[0] = {
                    ...updatedFormData[0],
                    isNextButtomClicked: true
                };

                dispatch(setMmRfqFormData(updatedFormData));
                alert("Please select at least 2 partners in each parts");
                return false;
            }
            if (MM_RFQ_FORM_DATA[0].expiryDate === null) {
                const updatedFormData = [...MM_RFQ_FORM_DATA];
                updatedFormData[0] = {
                    ...updatedFormData[0],
                    isNextButtomClicked: true
                };

                dispatch(setMmRfqFormData(updatedFormData));
                alert("Please select expiry date");
                return false;
            }
        }

        // Add more validations for other steps if needed
        return true;
    };

    const handleNext = () => {
        if (!validateStep()) return;

        if (activeStep < steps?.length - 1) {
            setActiveStep((prev) => prev + 1);
        }

        if (activeStep === 2) {
            setOpenRemoveDialog(true);
        }
    };

    const handleBack = () => {
        if (
            locationData?.from === "EditDueDateOfMMrfq" ||
            locationData?.from === "addPartnerForMMrfq"
        ) {
            const confirmLeave = window.confirm(
                "Changes you made may not be saved."
            );
            if (confirmLeave) {
                navigate("/layout/AllMmrfq", {
                    state: {
                        rfqData: {
                            ID: locationData?.rfqData?.ID,
                            rfqID: locationData?.rfqData?.rfqID,
                            assigneeName: locationData?.rfqData?.assigneeName
                        },
                        from: "CURFQAssignedToMe"
                    }
                });
            }
        } else if (activeStep > 0) {
            setActiveStep((prev) => prev - 1);
        } else {
            const confirmLeave = window.confirm(
                "Changes you made may not be saved."
            );
            if (confirmLeave) {
                navigate("/layout/CURFQAssignedToMe");
            }
        }
    };
    const renderPage = () => {
        switch (activeStep) {
            case 0:
                return <ConfirmRfqDetails />;
            case 1:
                return <AddDocuments />;
            case 2:
                return <SelectVendor />;
            default:
                return null;
        }
    };
    // useBeforeUnloadPrompt(
    //   true,
    //   "You have unsaved changes. Are you sure you want to leave?"
    // );
    const navigate = useNavigate();

    // useEffect(() => {
    //   const wasReloaded = sessionStorage.getItem("reloaded");
    //   if (wasReloaded === "true") {
    //     sessionStorage.removeItem("reloaded");
    //     navigate("/layout/CURFQAssignedToMe");
    //   }
    // }, [navigate]);

    useEffect(() => {
        window.history.pushState(null, "", window.location.pathname);
        window.addEventListener("popstate", onBackButtonEvent);

        window.onbeforeunload = () =>
            "Data will be lost if you leave the page, are you sure?";

        return () => {
            window.removeEventListener("popstate", onBackButtonEvent);
            window.onbeforeunload = null;
        };
    }, []);

    const onBackButtonEvent = (e) => {
        e.preventDefault();
        const confirmLeave = window.confirm(
            "Changes you made may not be saved."
        );
        if (confirmLeave) {
            navigate("/layout/CURFQAssignedToMe");
        } else {
            window.history.pushState(null, "", window.location.pathname);
        }
    };
    console.log("4444444", MM_RFQ_FORM_DATA[0]?.Rfq_Details?.MMRFQ_ID);
    return (
        <>
            {MM_RFQ_FORM_DATA?.length > 0 ? (
                <Paper sx={{ padding: "15px" }}>
                    <Stepper
                        activeStep={activeStep}
                        sx={{ paddingTop: "10px" }}
                    >
                        {steps?.map((label, index) => (
                            <Step key={index}>
                                <StepLabel
                                    sx={{
                                        "& .MuiStepIcon-root.Mui-completed": {
                                            color: "green"
                                        }
                                    }}
                                >
                                    {label}
                                </StepLabel>{" "}
                            </Step>
                        ))}
                    </Stepper>

                    <Box mt={3}>
                        {renderPage()}
                        <BtnFooter
                            activeStep={activeStep}
                            handleBack={handleBack}
                            handleNext={handleNext}
                            stepsLength={steps?.length}
                            MM_RFQ_FORM_DATA={MM_RFQ_FORM_DATA}
                        />
                    </Box>
                </Paper>
            ) : (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="50vh"
                >
                    <ThreeDot
                        color="#1976d2"
                        size="medium"
                        text=""
                        textColor=""
                    />
                </Box>
            )}

            {/* Confirmation Dialog */}
            <Dialog open={openRemoveDialog} onClose={handleCloseDialog}>
                <DialogTitle fontWeight={"bold"}>
                    {locationData?.from === "EditDueDateOfMMrfq"
                        ? "Extend End-Date"
                        : locationData?.from === "addPartnerForMMrfq"
                          ? "Add a New Partner"
                          : "Submit MMRFQ"}
                </DialogTitle>
                <DialogContent>
                    <Typography sx={{ color: "text.secondary" }}>
                        {locationData?.from === "EditDueDateOfMMrfq" ? (
                            <>
                                Are you sure you want to extend the MMRFQ end
                                date? This action will apply to all part(s) of{" "}
                                <b>
                                    {MM_RFQ_FORM_DATA[0]?.Rfq_Details?.MMRFQ_ID}
                                </b>{" "}
                                whose quotes are not yet approved.
                            </>
                        ) : locationData?.from === "addPartnerForMMrfq" ? (
                            <>
                                You have added{" ("}
                                <b>
                                    {
                                        MM_RFQ_FORM_DATA[0]?.Part_Details[0]?.selectedVendors?.filter(
                                            (item) =>
                                                !MM_RFQ_FORM_DATA[0]?.Part_Details[0]?.previousSelectedVendors?.includes(
                                                    item
                                                )
                                        )?.length
                                    }
                                </b>
                                {") "}
                                new partner(s) for{" "}
                                <b>
                                    {
                                        MM_RFQ_FORM_DATA[0]?.Part_Details[0]
                                            ?.Part_ID
                                    }
                                </b>{" "}
                                of{" "}
                                <b>
                                    {MM_RFQ_FORM_DATA[0]?.Rfq_Details?.MMRFQ_ID}
                                </b>
                                . Do you wish to proceed?
                            </>
                        ) : (
                            "MMRFQ will be published for the parts and sent to the respective partners selected. Do you wish to proceed?"
                        )}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="error">
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            if (locationData?.from === "EditDueDateOfMMrfq") {
                                updateExtendDate();
                            } else if (
                                locationData?.from === "addPartnerForMMrfq"
                            ) {
                                updatePartnerPerParts();
                            } else {
                                uploadForm();
                            }
                        }}
                        disabled={isAssigning}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.modal + 1,
                    backgroundColor: "rgba(0,0,0,0.7)"
                }}
                open={isAssigning}
            >
                <ThreeDot color="#1976d2" size="medium" text="" textColor="" />
            </Backdrop>
        </>
    );
};

const mapStateToProps = createStructuredSelector({
    MM_RFQ_FORM_DATA: mmRfqFormDataSelector
});

export default connect(mapStateToProps)(StepperComponent);
